"use client"
import React from 'react'
import Navbar from '../../components/admin/common/Navbar'
import MainLeads from '../../components/admin/Lead/MainLead'

const HomePage = () => {

  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:p-8">
     <MainLeads/>
    </main>
  </div>
  )
}

export default HomePage
